  document.addEventListener("DOMContentLoaded", function() {
    // Inicializar tabs
    const tabs = document.querySelectorAll("#geometria-tabs a");
    const contents = document.querySelectorAll(".geometria-content");
    
    tabs.forEach(tab => {
      tab.addEventListener("click", function(e) {
        e.preventDefault();
        
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));
        
        this.classList.add("active");
        const targetTab = document.querySelector(this.getAttribute("href"));
        if (targetTab) {
          targetTab.classList.add("active");
        }
      });
    });
    
    if (tabs.length > 0) {
      tabs[0].classList.add("active");
      const firstTabContent = document.querySelector(tabs[0].getAttribute("href"));
      if (firstTabContent) {
        firstTabContent.classList.add("active");
      }
    }
  });